import ArrowDropDown from '@mui/icons-material/ArrowDropDown';
import { FixMe } from '@greenkub-fronts/shared/interface';

export function ArrowDropDownIcon(props: FixMe) {
  return <ArrowDropDown {...props} />;
}

export default ArrowDropDownIcon;
